import {
  DefaultOldCockpitTiles,
  DefaultOldCockpitTilesForSpecialMode,
  SpecialTutorialTiles,
  TilesInterface
} from './tiles';
import { TutorialContext, TutorialEnum } from '../../handlers/TutorialHandler';
import { useContext, useEffect } from 'react';
import { useTour } from '@reactour/tour';
import { TilesContext } from '../../handlers/TilesHandler';
import { TutorialTiles } from './tiles';
import { swapTiles } from '../../helpers/tilesHelper';
import { TrackEventParams } from '@datapunt/matomo-tracker-react/lib/types';
import { MatomoAction, MatomoCategory } from '../../Constants';

export const useHandleTutorialLogic = (
  setMountDrawer: React.Dispatch<boolean>,
  setVisibleDrawer: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { tutorialType } = useContext(TutorialContext);
  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep } = useTour();
  const { mainTiles, setMainTiles } = useContext(TilesContext);
  const { isInSpecialMode } = useContext(TilesContext);

  useEffect(() => {
    if (tutorialType === TutorialEnum.one) {
      if (isOpen) {
        setVisibleDrawer(true);
        if (currentStep === 0) {
          setMountDrawer(false);
          setMainTiles(
            isInSpecialMode
              ? DefaultOldCockpitTilesForSpecialMode
              : DefaultOldCockpitTiles
          );
        } else if (currentStep === 1) {
          setMountDrawer(true);
        } else if (currentStep === 2) {
          setMainTiles(tiles => {
            const newTiles = [...tiles]; // Creates a copy of the tiles array
            newTiles[0] = {
              ...newTiles[0], // Creates a copy of the first tile
              name: isInSpecialMode ? 'amount-of-waste' : 'energy'
            };
            return newTiles;
          });
          setMountDrawer(false);
        } else if (currentStep >= steps.length) {
          setIsOpen(false);
          setMainTiles(mainTiles);
          setCurrentStep(0);
        }
      } else {
        setVisibleDrawer(false);
      }
    }
    if (tutorialType === TutorialEnum.two && currentStep >= steps.length) {
      setIsOpen(false);
      setCurrentStep(0);
    }

    if (tutorialType === TutorialEnum.three) {
      currentStep === 0 &&
        setMainTiles(isInSpecialMode ? SpecialTutorialTiles : TutorialTiles);
      currentStep === 4 &&
        setMainTiles(
          isInSpecialMode
            ? DefaultOldCockpitTilesForSpecialMode
            : DefaultOldCockpitTiles
        );
      currentStep === 5 &&
        setMainTiles(isInSpecialMode ? SpecialTutorialTiles : TutorialTiles);

      if (currentStep >= steps.length) {
        setIsOpen(false);
        setCurrentStep(0);
      }
    }

    if (!isOpen) {
      setMountDrawer(true);
    }
  }, [isOpen, currentStep, isOpen]);
};

export const openDrawer = (
  e: React.MouseEvent,
  key: string,
  setCurrentTileKey: React.Dispatch<React.SetStateAction<string | undefined>>,
  setVisibleDrawer: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (e.button === 0) {
    e.stopPropagation();
    setCurrentTileKey(key);
    setVisibleDrawer(true);
  }
};

export const handleDragEnd = (
  draggedTile: undefined | string,
  draggedOverTile: undefined | string,
  setMainTiles: React.Dispatch<React.SetStateAction<TilesInterface[]>>,
  trackEvent: (params: TrackEventParams) => void | undefined
) => {
  if (draggedTile && draggedOverTile) {
    if (draggedOverTile !== draggedTile) {
      trackEvent({
        category: MatomoCategory.Tiles,
        action: MatomoAction.TilesRearranged
      });
      setMainTiles(tiles => swapTiles(tiles, draggedTile, draggedOverTile));
    }
  }
};
